import { motion, useReducedMotion } from "framer-motion";
import { Reveal, MaskedHeading } from "../Reveal";
import { IMAGES } from "../../data/content";

export default function Dolphins() {
  const reduced = useReducedMotion();
  return (
    <section className="section bg-abyss relative overflow-hidden" data-testid="dolphins-section">
      {/* Grande photographie pleine largeur */}
      <motion.div
        className="relative h-[52vh] md:h-[70vh] overflow-hidden"
        initial={reduced ? { opacity: 0 } : { opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2 }}
      >
        <img
          src={IMAGES.dolphins}
          alt="Groupe de dauphins sauvages nageant librement dans une mer profonde et lumineuse"
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-abyss via-abyss/20 to-abyss/40" />
      </motion.div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-32 -mt-24 relative z-10">
        <span className="chapter-num">CHAPITRE 06 — LE VIVANT</span>
        <MaskedHeading
          tag="h2"
          className="font-display font-medium text-[clamp(2.6rem,6vw,5rem)] leading-none tracking-tight text-pearl mt-6"
          lines={["Pourquoi les dauphins ?"]}
        />

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mt-12">
          <Reveal className="lg:col-span-5 space-y-5">
            <p className="text-aqua text-lg leading-relaxed">
              Les dauphins ne sont pas ici pour rendre la page plus jolie.
            </p>
            <p className="text-pearl/75 text-lg leading-relaxed">
              Ils ne sont pas un décor exotique ni une promesse de guérison magique. Ils
              représentent une manière singulière d'habiter le vivant.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7 space-y-5 text-pearl/75 text-base leading-relaxed">
            <p>
              Les dauphins sont des animaux sociaux complexes, capables de coopération, de
              communication, d'apprentissage, de jeu et de relations durables au sein de
              leurs groupes.
            </p>
            <p>Leur présence nous touche aussi symboliquement.</p>
            <p>
              Ils nous rappellent qu'une intelligence ne se manifeste pas uniquement dans
              le contrôle, la gravité ou l'accumulation de savoir. Elle peut aussi
              apparaître dans la qualité du lien, l'adaptation, le mouvement, la curiosité
              et le jeu.
            </p>
            <p>
              Depuis près de deux décennies, Gilles Delieuze explore la relation
              symbolique, sensible et spirituelle que l'être humain peut entretenir avec
              leur énergie et leur présence.
            </p>
            <p>
              La Traversée ne prétend pas transformer une interprétation spirituelle en
              vérité scientifique. Elle utilise les dauphins comme des maîtres symboliques
              du vivant : des invitations à retrouver davantage de présence, de fluidité,
              de lien, de joie et d'intelligence collective.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mt-20 max-w-4xl mx-auto text-center">
          <p className="pull-quote text-[clamp(1.7rem,4vw,3.2rem)] text-pearl">
            « Et si avancer ne consistait pas toujours à pousser plus fort, mais parfois à
            retrouver la manière juste de bouger avec le vivant ? »
          </p>
        </Reveal>
      </div>
    </section>
  );
}
